import { call, put, select } from 'redux-saga/effects';
import { toastr } from 'react-redux-toastr';
import * as Api from '../../../../services/fbm-api';
import { sagaRoutineRequest } from '../../../../helpers/saga';
import {
  fetchCurrentPantry as fetchCurrentPantryRoutine,
  createPantry as createPantryRoutine,
  updatePantry as updatePantryRoutine,
  fetchPortalUsers as fetchPortalUsersRoutine,
  syncPortalUserGuestAddress as syncPortalUserGuestAddressRoutine,
  syncPortalUserGuestPhone as syncPortalUserGuestPhoneRoutine
} from './routines';
import { getSmtpAccounts } from '../../selectors/portal/smtp-account';
import { getOrder } from '../../selectors/portal/user';
import { getPaginationQueryOptions } from '../../selectors/portal/user/pagination';
import { getSettingsPortalUserSearchQuery } from '../../selectors/components/portal/user-search';
import { portalUsersOnClear } from '../../actions/portal/user';
import { settingsPortalSmtpAccountPath } from '../../../../routes/Paths';
import history from '../../../../routes/history';

export const fetchCurrentPantry = ({ payload: body }) =>
  sagaRoutineRequest(fetchCurrentPantryRoutine, {
    request: () => call(Api.fetchCurrentPantry, { body })
  });

export const createPantry = ({ payload: body }) =>
  sagaRoutineRequest(createPantryRoutine, {
    request: () => call(Api.createPantry, { body }),
    *success() {
      yield toastr.success('Success', 'Portal successfully created.');
      const smtpAccounts = yield select(getSmtpAccounts);
      if (!smtpAccounts.length) {
        history.push(settingsPortalSmtpAccountPath);
      }
    }
  });

export const updatePantry = ({ payload: { id, body } }) =>
  sagaRoutineRequest(updatePantryRoutine, {
    request: () => call(Api.updatePantry, { id, body }),
    *success() {
      yield toastr.success('Success', 'Portal successfully updated.');
      const smtpAccounts = yield select(getSmtpAccounts);
      if (!smtpAccounts.length) {
        history.push(settingsPortalSmtpAccountPath);
      }
    }
  });

export const fetchPortalUsers = ({ payload: qs }) =>
  sagaRoutineRequest(fetchPortalUsersRoutine, {
    request: () => call(Api.fetchPortalUsers, { qs })
  });

function* refreshPortalUsers() {
  const order = yield select(getOrder);
  const paginationQuery = yield select(getPaginationQueryOptions);
  const searchQuery = yield select(getSettingsPortalUserSearchQuery);
  yield put(portalUsersOnClear());
  yield put(
    fetchPortalUsersRoutine({
      ...paginationQuery,
      ...searchQuery,
      order
    })
  );
}

export const syncPortalUserGuestAddress = ({ payload: id }) =>
  sagaRoutineRequest(syncPortalUserGuestAddressRoutine, {
    request: () => call(Api.syncPortalUserGuestAddress, id),
    *success() {
      yield toastr.success(
        'Success',
        'Internal guest address was updated from the Portal address.'
      );
      yield refreshPortalUsers();
    }
  });

export const syncPortalUserGuestPhone = ({ payload: id }) =>
  sagaRoutineRequest(syncPortalUserGuestPhoneRoutine, {
    request: () => call(Api.syncPortalUserGuestPhone, id),
    *success() {
      yield toastr.success(
        'Success',
        'Internal guest phone numbers were updated from the Portal phone numbers.'
      );
      yield refreshPortalUsers();
    }
  });
